// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3XLwD","row":"styles_row__1gYux"};